import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
import { paginationMetaSchema, paginationQuerySchema } from './pagination.js';
/**
 * Kurzreferenz eines protokollierten Fehlers. Sie wird dem Benutzer angezeigt und
 * verbindet Toast, Support-Anfrage und Fehlerzentrale.
 */
export const errorTrackingIdSchema = z.string().regex(/^ERR-[0-9A-Z]{4,12}$/u);
export const systemErrorLogSchema = z.object({
    id: idSchema,
    errorTrackingId: errorTrackingIdSchema,
    errorCode: z.string(),
    httpStatus: z.number().int(),
    message: z.string(),
    endpoint: z.string(),
    httpMethod: z.string(),
    userId: idSchema.nullable(),
    userName: z.string().nullable(),
    userRole: z.string().nullable(),
    ipAddress: z.string().nullable(),
    isResolved: z.boolean(),
    resolvedAt: isoDateTimeSchema.nullable(),
    createdAt: isoDateTimeSchema,
});
export const systemErrorLogDetailSchema = systemErrorLogSchema.extend({
    stackTrace: z.string().nullable(),
    userAgent: z.string().nullable(),
    requestPayload: z.unknown().nullable(),
    queryParams: z.unknown().nullable(),
    contextData: z.unknown().nullable(),
    resolvedByUserId: idSchema.nullable(),
    resolvedByName: z.string().nullable(),
    resolvedNotes: z.string().nullable(),
});
export const systemErrorLogListQuerySchema = paginationQuerySchema.omit({ sort: true }).extend({
    /** Volltextsuche über Referenz-ID, Meldung und Endpunkt. */
    q: z.string().trim().max(200).optional(),
    userId: idSchema.optional(),
    httpStatus: z.coerce.number().int().min(100).max(599).optional(),
    unresolvedOnly: z
        .preprocess((value) => (typeof value === 'string' ? value === 'true' : value), z.boolean())
        .optional(),
    from: isoDateTimeSchema.optional(),
    to: isoDateTimeSchema.optional(),
});
export const systemErrorLogListResponseSchema = z.object({
    data: z.array(systemErrorLogSchema),
    meta: paginationMetaSchema,
    summary: z.object({
        unresolvedCount: z.number().int().min(0),
        last24hCount: z.number().int().min(0),
    }),
});
export const systemErrorLogResolveSchema = z.object({
    isResolved: z.boolean(),
    resolvedNotes: z.string().trim().max(2000).nullish(),
});
//# sourceMappingURL=system-error-log.js.map